import styles from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/ContentElements/Accordion/AccordionTableRow/AccordionTableRow.css';

export const prototypeName = 'XK6AvanLpVT0Rdel2jkOCnLWWNv2AlSaAqOqaxwWSzvrVDjDPNiVWNW4JMGWtO85j1qPK4iZQJn872OvU9j7VPzd4KH10oqJ1pnnC6PXG4';
export {styles};